module.exports = __webpack_public_path__ + "img/center_headBack.240d5b62.png";